"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const errors_1 = require("@seneca/errors");
/**
 * Thrown when the operation requested gets an unexpected response from the
 * service. This can be due to pointing at the wrong service / version
 * @param {string} method
 * @param {string} url
 * @param {number} status
 */
class UnexpectedServerResponse extends errors_1.ExtendableError {
    constructor(method, url, status, correlationId) {
        super(`Unexpected response - ${status}, for ${method} - ${url} - correlationId: ${correlationId}`);
    }
}
exports.default = UnexpectedServerResponse;
